import * as React from 'react';

interface Props {
    message: string;
    type: 'negative' | 'success';
}

export class Alert extends React.Component<Props> {
    render() {
        const cssClass = 'ui message ' + this.props.type;

        return (<div className={cssClass}>{this.props.message}</div>);
    }
};



// WEBPACK FOOTER //
// ./src/components/common/alert/alert.presentation.tsx